import Programs from '../Programs/Programs';
import ProgramsV22 from '../ProgramsV22/ProgramsV22';
import { useFeatureFlagVariantKey } from 'posthog-js/react';

export default function ProgramsV22ExperimentEntry() {
    const variant = useFeatureFlagVariantKey('programs-v2-2-experiment');

    if (variant === 'test') {
        return <ProgramsV22 />;
    }

    return <Programs />;
}
